import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Signup from "./pages/Signup";
import "./index.css";

// The public /signup page is a standalone route with no admin/tenant chrome and
// no Heady SDK dependency — render it directly when the path matches.
const isSignup = window.location.pathname.replace(/\/+$/, "") === "/signup";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    {isSignup ? <Signup /> : <App />}
  </React.StrictMode>
);
